<template>
  <div class="field">
    <div class="is-flex">
      <label class="is-size-6 is-expanded">{{ label }}</label>
      <label class="required-label is-size-7" style="margin-top: 4px;">{{
        required ? "required" : "optonal"
      }}</label>
    </div>
    <div class="control">
      <textarea
        class="textarea"
        :type="type"
        :placeholder="placeholder"
        v-model="model"
        :class="{ 'is-danger': valid === false, 'is-success': valid === true }"
      >
      </textarea>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      default: "Label"
    },
    type: {
      type: String,
      default: "text"
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ""
    },
    value: {
      required: true
    },
    valid: {
      default: "unset"
    }
  },
  data() {
    return {
      model: ""
    };
  },
  watch: {
    value() {
      let component = this;
      component.model = component.value;
    },
    model() {
      let component = this;
      component.$emit("input", component.model);
    }
  }
};
</script>
<style lang="scss" scoped></style>
